import React, { useEffect, useState } from 'react';import { List, Datagrid, TextField, TextInput, Button, BooleanInput, FunctionField, ResourceContextProvider, Filter, Loading, useDataProvider, ReferenceInput, AutocompleteInput } from 'react-admin';import {useHistory} from 'react-router-dom';

import { CardHeader } from '@material-ui/core';import { green, orange, deepOrange } from '@mui/material/colors';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';

import { TextFieldShow, TextHtmlShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

import { DateTimeSecondsField } from './../common/utils';  

import { validateMaxLength } from './../components/Validator';

const formatDateTime = value => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
};

const normalizeEmailContent = value => {
  if (!value) return '';
  const matches = value.match(/\*{10}/g);
  return matches && matches.length > 20 ? value.replace(/\*{10}/g, '') : value;
};

export const EmailsHistoryList = (props) => {
  const translate = useTranslate();  
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const associationsId = isSuperAdmin ? -1 : localStorage.getItem('associations_id');
    
  let basePath='/emails'; 
  let resource = props.target && props.item ? 'emails/status-history' : 'emails';
  let strRedirect = 'emails';
  const listFilter = props.target && props.item
    ? { target: props.target, item: props.item }
    : { ...(isSuperAdmin ? {} : { associations_id : associationsId }), users_id : props.users_id ? props.users_id : -1 };
    
  return (
          <>
      <br/>
      { !props.show ?
      <Typography variant="h5" className="grey8" align="center">
        {translate('settings.emails_logs')}              
      </Typography> : null }
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={listFilter}  
        actions={null}    
        empty={null}        
        bulkActionButtons={false}          
        perPage={props.show ? 10 : 50}   
        sort={{ field: 'id', order: 'DESC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={ !props.show? <MyFilter /> : null } 
        filterDefaultValues={ { q: "", only_not_sent: false }}
      >        
        <Datagrid 
          rowClick={null}
          expand={<EmailsDetails />} >                                                 
          <DateTimeSecondsField source="date_ordered" label={translate('emails.date_ordered')} sortable={false} />  
          { isSuperAdmin && !props.show ? <TextField source="associations_name" label={translate('settings.association')} sortable={false} /> : null }
          <FunctionField label={translate('emails.from')} render={record => record.from_name + ' <' + record.from_email + '>'} sortable={false}  />
          { !props.show && !isSuperAdmin ? <UserLinkButton label={translate('emails.contact')} /> : null }
          <FunctionField label={translate('emails.to')} render={record => <>{record.to}</>} sortable={false}  />          
          <TextField source="subject" label={translate('emails.subject')} sortable={false} />                      
          <FunctionField label={translate('remittances.status')} render={record => <RenderStatus record={record} />} />
        </Datagrid>        
      </List>
    </ResourceContextProvider>
    </>
  );
};

export const EmailsHistoryTable = ({ target, item }) => {
  const translate = useTranslate();
  const dataProvider = useDataProvider();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dataProvider.getList('emails/status-history', {
      pagination: { page: 1, perPage: 25 },
      sort: { field: 'id', order: 'DESC' },
      filter: { target, item }
    })
      .then(({ data }) => {
        setData(data || []);
        setLoading(false);
      })
      .catch(() => {
        setData([]);
        setLoading(false);
      });
  }, [dataProvider, target, item]);

  if (loading) return <Loading />;

  const dataById = data.reduce((acc, record) => {
    acc[record.id] = record;
    return acc;
  }, {});

  return (
    <ResourceContextProvider value="emails">
      <Datagrid
        data={dataById}
        ids={data.map(record => record.id)}
        loaded
        currentSort={{ field: 'id', order: 'DESC' }}
        basePath="/emails"
        rowClick={null}
        expand={<EmailsDetails />}
      >
        <DateTimeSecondsField source="date_ordered" label={translate('emails.date_ordered')} sortable={false} />
        <FunctionField label={translate('emails.from')} render={record => record.from_name + ' <' + record.from_email + '>'} sortable={false} />
        <FunctionField label={translate('emails.to')} render={record => <>{record.to}</>} sortable={false} />
        <TextField source="subject" label={translate('emails.subject')} sortable={false} />
        <FunctionField label={translate('remittances.status')} render={record => <RenderStatus record={record} />} />
      </Datagrid>
    </ResourceContextProvider>
  );
};

const UserLinkButton = ({ record, ...props }) => {
    const translate = useTranslate();
    const history = useHistory();

    const handleClick = () => {
            history.push('/users/' + record.users_id + '/show');  
    };
    if (record.users_id)
        return <Button {...props} label="" onClick={handleClick} startIcon={<PersonIcon />} />;
    else
        return null;
    
};

export function RenderStatus( { record } )
{
    const translate = useTranslate(); 
    const sesStatus = getAwsSesStatus(record, translate);
    let title = sesStatus ? sesStatus.title : translate('emails.status_' + record.status);
    let subheader = sesStatus ? sesStatus.subheader : null;

    if (record.status === 0) 
        return (<CardHeader
            avatar={<Avatar sx={{ bgcolor: orange[500] , width: 30, height: 30 }} ><CloseIcon/></Avatar> }
            title={title}
            subheader={subheader}
            className="remittanceStatusIcon"
        />);

    else if (record.status === 1) 
        return (<CardHeader
            avatar={<Avatar sx={{ bgcolor: orange[500] , width: 30, height: 30 }} ><ForwardToInboxIcon/></Avatar> }
            title={title}
            subheader={subheader}
            className="remittanceStatusIcon"
        />);

    else if (record.status === 2)
        return (<CardHeader
            avatar={<Avatar sx={{ bgcolor: deepOrange[500] , width: 30, height: 30 }} ><CloseIcon/></Avatar> }
            title={title}
            subheader={subheader}
            className="remittanceStatusIcon"
        />);

    else if (record.status === 3)
        return (<CardHeader
            avatar={<Avatar sx={{ bgcolor: green[500] , width: 30, height: 30 }} ><DoneIcon/></Avatar> }
            title={title}
            subheader={subheader}
            className="remittanceStatusIcon"
        />);
    
    else if (record.status === 4)
        return (<CardHeader
            avatar={<Avatar sx={{ bgcolor: deepOrange[500] , width: 30, height: 30 }} ><CloseIcon/></Avatar> }
            title={title}
            subheader={subheader}
            className="remittanceStatusIcon"
        />);
    
    return null;
}

const getAwsSesStatus = (record, translate) => {
  if (record.delivery_provider !== 'aws_ses' && !record.aws_ses_message_id) return null;

  const items = [
    { date: record.clicked_at, key: 'emails.aws_ses_status_clicked' },
    { date: record.opened_at, key: 'emails.aws_ses_status_opened' },
    { date: record.delivered_at, key: 'emails.aws_ses_status_delivered' },
    { date: record.bounced_at, key: 'emails.aws_ses_status_bounced' },
    { date: record.complained_at, key: 'emails.aws_ses_status_complained' }
  ].filter(item => item.date);

  const latest = items.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
  if (latest) {
    return {
      title: translate(latest.key),
      subheader: formatDateTime(latest.date)
    };
  }

  if (record.status === 2 || record.status === 4) {
    return { title: translate('emails.aws_ses_status_error'), subheader: null };
  }
  if (record.status === 3) {
    return { title: translate('emails.aws_ses_status_sent'), subheader: null };
  }
  if (record.status === 1) {
    return { title: translate('emails.aws_ses_status_sending'), subheader: null };
  }
  return { title: translate('emails.aws_ses_status_pending'), subheader: null };
};

const ColoredTextFieldShow = ({ source, label, color }) => {
  const valueColor = source && source !== '-' ? color : 'inherit';
  return (
    <>
      <br/><span className="custom-field-title grey6">{label}</span><br/>
      <span style={{ color: valueColor }}>{source}</span>
    </>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
    return (
    <Filter {...props}>
        { isSuperAdmin ?
        <ReferenceInput
          label={translate('settings.association')}
          source="associations_id"
          reference="associations"
          sort={{ field: 'name', order: 'ASC' }}
          perPage={50}
          alwaysOn
        >
          <AutocompleteInput
            optionText="name"
            optionValue="id"
            suggestionLimit={50}
            resettable
            clearAlwaysVisible
            filterToQuery={searchText => ({ q: searchText })}
          />
        </ReferenceInput> : null }
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable /> 
        <BooleanInput label={translate('emails.only_not_sent')} source="only_not_sent" alwaysOn />
    </Filter>
);
};

export const EmailsDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
  const isSuperAdmin = ['SIFAC'].includes(localStorage.getItem('permissions_groups'));
  const hasSesInfo = record.delivery_provider === 'aws_ses' || record.aws_ses_message_id
    || record.delivered_at || record.bounced_at || record.complained_at || record.opened_at || record.clicked_at;
  const showSesMessageId = isSuperAdmin && (record.delivery_provider === 'aws_ses' || record.aws_ses_message_id);
        
  return (
    <div className="emails-details">        
      <Grid container spacing={2}>   
        { record.error_message ?
        <Grid item xs={12} >   
          <span className="bg-red p-5">{record.error_message}</span><br/><br/>
        </Grid> : null }
        { hasSesInfo ?
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} md={2}><ColoredTextFieldShow source={formatDateTime(record.delivered_at)} label={translate('emails.delivered_at')} color="#2e7d32" /></Grid>
            <Grid item xs={12} sm={6} md={2}><ColoredTextFieldShow source={formatDateTime(record.opened_at)} label={translate('emails.opened_at')} color="#2e7d32" /></Grid>
            <Grid item xs={12} sm={6} md={2}><ColoredTextFieldShow source={formatDateTime(record.clicked_at)} label={translate('emails.clicked_at')} color="#2e7d32" /></Grid>
            <Grid item xs={12} sm={6} md={2}><ColoredTextFieldShow source={formatDateTime(record.bounced_at)} label={translate('emails.bounced_at')} color="#d32f2f" /></Grid>
            <Grid item xs={12} sm={6} md={2}><ColoredTextFieldShow source={formatDateTime(record.complained_at)} label={translate('emails.complained_at')} color="#d32f2f" /></Grid>
          </Grid>
        </Grid> : null }
        { showSesMessageId ? <Grid item xs={12}><TextFieldShow source={record.aws_ses_message_id || '-'} label={translate('emails.aws_ses_message_id')} /></Grid> : null }
        <Grid item xs={12}>   
          <TextHtmlShow source={normalizeEmailContent(record.content)} label={translate('emails.content')} html={true} />
        </Grid> 
        { record.docs ?
        <Grid item xs={12}>   
          <TextFieldShow source={record.docs} label={translate('emails.docs')} />
        </Grid> : null }        
      </Grid>
      
    </div>
  );
};

/*
const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        target: item.target,
        users_id: item.users_id,
        groups_id: item.groups_id,
        events_id: item.events_id,
        bookings_id: item.bookings_id,
        date_ordered: dateOnlyToCatalan(item.date_ordered),
        from_name: item.from_name,
        from_email: item.from_email,
        to: item.to,
        cc: item.cc,
        bcc: item.bcc,
        subject: item.subject,
        content: item.content,
        docs: item.docs,
        date_sent: dateOnlyToCatalan(item.date_sent),
        status: item.status,
        reply_to: item.reply_to,
        remittances_users_id: item.remittances_users_id,
        users_groups_id: item.users_groups_id,
        users_permissions_id: item.users_permissions_id,
        users_annuary_id: item.users_annuary_id,
        error_message: item.error_message,
        recercat_centers_id: item.recercat_centers_id,
        users_login_id: item.users_login_id,
        donations_users_id: item.donations_users_id,
        donations_projects_id: item.donations_projects_id,
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','target'
,'users_id'
,'groups_id'
,'events_id'
,'bookings_id'
,'date_ordered'
,'from_name'
,'from_email'
,'to'
,'cc'
,'bcc'
,'subject'
,'content'
,'docs'
,'date_sent'
,'status'
,'reply_to'
,'remittances_users_id'
,'users_groups_id'
,'users_permissions_id'
,'users_annuary_id'
,'error_message'
,'recercat_centers_id'
,'users_login_id'
,'donations_users_id'
,'donations_projects_id'
],
    rename: [translate('common.id'),translate('emails.target'),translate('emails.users_id'),translate('emails.groups_id'),translate('emails.events_id'),translate('emails.bookings_id'),translate('emails.date_ordered'),translate('emails.from_name'),translate('emails.from_email'),translate('emails.to'),translate('emails.cc'),translate('emails.bcc'),translate('emails.subject'),translate('emails.content'),translate('emails.docs'),translate('emails.date_sent'),translate('emails.status'),translate('emails.reply_to'),translate('emails.remittances_users_id'),translate('emails.users_groups_id'),translate('emails.users_permissions_id'),translate('emails.users_annuary_id'),translate('emails.error_message'),translate('emails.recercat_centers_id'),translate('emails.users_login_id'),translate('emails.donations_users_id'),translate('emails.donations_projects_id')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('emails.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};
*/
